import { Trash } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MetaInteraction } from '../meta-interaction';

export type MetaDeleteHabitProps = {
  onDelete: () => void;
};

export const MetaDeleteHabit: React.FC<MetaDeleteHabitProps> = ({
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <MetaInteraction
      icon={Trash}
      label={t('general.labels.delete')}
      placeholder={t('general.labels.delete')}
      onClick={onDelete}
    />
  );
};
